import { render, staticRenderFns } from "./BaseInfoTab.vue?vue&type=template&id=1a6c5889&scoped=true"
import script from "./BaseInfoTab.vue?vue&type=script&lang=js"
export * from "./BaseInfoTab.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoTab.vue?vue&type=style&index=0&id=1a6c5889&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c5889",
  null
  
)

export default component.exports